





































































































































































import IListAdressTypes from '@/store/models/IListAdressTypes';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListAdressTypesSelector extends Vue {
    searchListAdressType: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'typeName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'typeName' },
        { text: 'Fiscal', value: 'isFiscal' },
        { text: 'Postal', value: 'isPostal' },
        { text: 'Billing', value: 'isBilling' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListAdressTypes = {
        id: "",
        typeName: "",
        isFiscal: false,
        isPostal: false,
        isBilling: false,
        idCompany: ""
    }
    defaultItem : IListAdressTypes = {
        id: "",
        typeName: "",
        isFiscal: false,
        isPostal: false,
        isBilling: false,
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListAdressTypeList !: IListAdressTypes[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListAdressType : IListAdressTypes[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Adress type' : 'Edit Adress type'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListAdressTypes() {
        this.selectedListAdressType = [];
    }

    editListAdressType (item: any, dbox = true) {
        this.editedIndex = this.ListAdressTypeList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListAdressType (listAdressType: IListAdressTypes) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListAdressType[0]) {
                this.close();
                this.$emit('editListAdressType', this.editedItem);
                Object.assign(this.ListAdressTypeList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListAdressType[0] = this.editedItem;
                this.$emit('saveListAdressType', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListAdressType (listAdressType: IListAdressTypes) {
        this.$emit('deleteListAdressType', listAdressType);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListAdressType(item : any) : void {
        if (!this.selectedListAdressType.includes(item)) {
            this.selectedListAdressType = [];
            this.selectedListAdressType = [item];
        } else {
            this.selectedListAdressType = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
